const styles = theme => ({
  formDescription: {
    fontSize: '14px',
  },
  boxForm: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
    },
  },
  selectWrapper: {
    maxWidth: '200px',
  },
});

export default styles;
